import { Menu } from "antd";
import { useEffect, useState } from "react";
import "./MainLayout.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../Context/UserContext";
import {
  BookOutlined,
  DiffTwoTone,
  HolderOutlined,
  IdcardTwoTone,
  LayoutTwoTone,
  ProfileTwoTone,
  ScheduleTwoTone,
  SettingOutlined,
  ShoppingTwoTone,
  ToolTwoTone,
  InteractionTwoTone,
} from "@ant-design/icons";
// import { useCompany } from "../Context/CompanyContext";

const Sidemenus: React.FC<{
  isCollapse: any;
  onsetSlide: any;
  styles: any;
  isSlide: any;
}> = (props: any) => {
  let loc = useLocation();
  const { isAuthenticated, isSuperAdmin, isSubAdmin } = useUser();
  // const { isFeatureExists } = useCompany();
  const [current, setCurrent] = useState(
    loc.pathname === "/" ? "/" : `/${loc.pathname.split("/")[1]}`
  );
  useEffect(() => {
    if (loc) {
      if (current !== loc.pathname) {
        setCurrent(`/${loc.pathname.split("/")[1]}`);
      }
    }
  }, [loc, current]);
  const navigate = useNavigate();
  const setSelectedMenuItem = (key: any) => {
    if (key) {
      navigate(key);
      props.onsetSlide(false);
      setCurrent(key);
    }
  };

  return (
    <>
      {isAuthenticated() ? (
        <Menu
          theme="light"
          style={props?.isSlide && props?.styles}
          mode="inline"
          inlineCollapsed={props.isCollapse}
          className="sidebar"
          defaultSelectedKeys={[current]}
          selectedKeys={[current]}
          onClick={(e) => setSelectedMenuItem(e.key)}
          items={[
            isSubAdmin() || isSuperAdmin()
              ? {
                key: "/dashboard",
                icon: <LayoutTwoTone />,
                label: <Link to="/dashboard">Dashboard</Link>,
              }
              : null,
            isSubAdmin() || isSuperAdmin()
              ? {
                key: "/practices",
                icon: <ShoppingTwoTone />,
                label: <Link to="/practices">Practices</Link>,
              }
              : null,
            isSubAdmin() || isSuperAdmin()
              ? {
                key: "/tickets",
                icon: <InteractionTwoTone />,
                label: <Link to="/tickets">Support Tickets</Link>,
              }
              : null,
            isSubAdmin() || isSuperAdmin()
              ? {
                key: "/updates",
                icon: <ToolTwoTone />,
                label: <Link to="/updates">Updates</Link>,
              }
              : null,
            isSubAdmin() || isSuperAdmin()
              ? {
                key: "/holidays",
                icon: <ProfileTwoTone />,
                label: <Link to="/holidays">Holidays</Link>,
              }
              : null,
            isSubAdmin() || isSuperAdmin()
              ? {
                key: "/ctconfiguration",
                icon: <ScheduleTwoTone />,
                label: <Link to="/ctconfiguration">CTConfiguration</Link>,
              }
              : null,
            isSubAdmin() || isSuperAdmin()
              ? {
                key: "/payrollyearlysettings",
                icon: <DiffTwoTone />,
                label: (
                  <Link to="/payrollyearlysettings">
                    Payroll Yearly Settings
                  </Link>
                ),
              }
              : null,
            // isSuperAdmin()
            //   ? {
            //     key: "/ApplicationConfigKey",
            //     icon: <ToolTwoTone />,
            //     label: (
            //       <Link to="/ApplicationConfigKey">
            //         Application Config Key
            //       </Link>
            //     ),
            //   }
            //   : null,
            isSuperAdmin()
              ? {
                key: "/submissionhold",
                icon: <HolderOutlined />,
                label: (
                  <Link to="/submissionhold">
                    Submission Hold
                  </Link>
                ),
              }
              : null,
            isSuperAdmin()
              ? {
                key: "/generalsettingbooks",
                icon: <BookOutlined />,
                label: (
                  <Link to="/generalsettingbooks">
                    Books General Settings
                  </Link>
                ),
              }
              : null,
            // isSuperAdmin()
            //   ? {
            //     key: "/userAuditLog",
            //     icon: <BookOutlined />,
            //     label: (
            //       <Link to="/userAuditLog">
            //         Logs
            //       </Link>
            //     ),
            //   }
            //   : null,
            isSuperAdmin()
              ? {
                key: "/adminusers",
                icon: <SettingOutlined />,
                label: "Setting",
                children: [
                  { key: 'adminusers', icon: <IdcardTwoTone />, label: <Link to="/adminusers">Users</Link> }
                ]
              }
              : null,
            //isSuperAdmin()
            //    ? {
            //        key: "/adminusers",
            //        icon: <IdcardTwoTone />,
            //        label: <Link to="/adminusers">Admin Users</Link>,
            //    }
            //    : null,
            // {
            //   key: "/sa100configuration",
            //   icon: <SnippetsTwoTone />,
            //   label: <Link to="/sa100configuration">SA100 Configuration</Link>,
            // },
          ]}
        />
      ) : null}
    </>
  );
};
export default Sidemenus;
